module.exports = __webpack_public_path__ + "static/media/folio-pasapets.6019775e.svg";